import { useState, useEffect } from 'react'

export const BOOKING_URL =
  'https://aws-portal.owlpractice.ca/arrivetherapy/booking'

export function navigate(hash: string) {
  window.location.hash = hash
  window.scrollTo(0, 0)
}

export function useRoute() {
  const [route, setRoute] = useState(window.location.hash || '#/')

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#/')
      window.scrollTo(0, 0)
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  return route
}
